import { css } from 'linaria';
import { styled } from 'linaria/react';

export const Container = styled.div<{ marginVertical?: string }>`
  position: relative;
  display: block;
  max-width: var(--layout-max-width);
  margin-block: ${({ marginVertical }) => marginVertical ?? 0}px;
`;

export const sectionDivider = css`
  @media (--from-tablet) {
    margin-block-start: 0;

    &::before {
      content: '';
      display: block;
      width: 100%;
      margin-block: var(--space-500);
      border-top: 1px solid var(--control-minor);
    }
  }
`;

export const remoteCarousel = css`
  @media (--from-tablet) {
    width: var(--layout-width);
  }

  @media (--to-tablet) {
    margin-right: var(--space-200);
    margin-left: var(--space-200);
  }

  div {
    font-family: Roboto, apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans',
      'Helvetica Neue', sans-serif !important;
  }

  [data-qa='products-carousel-seemore-link'] {
    font-size: 16px;

    span [role='presentation'] {
      width: 9px !important;
      height: 9px !important;
    }
  }
`;

export const CarouselContainer = styled.div`
  padding: 24px 16px;
  background: var(--background-primary);
  margin-bottom: 28px;

  @media (min-width: 768px) and (max-width: 1023px) {
    padding: 24px 0px;
    margin-bottom: 48px;
    box-shadow: -500px 0 0 0 var(--background-primary), 500px 0 0 0 var(--background-primary);
  }

  @media (min-width: 1200px) {
    max-width: 1180px;
    border: 1px solid var(--control-minor);
  }

  @media (max-width: 768px) {
    padding: 24px 0px;
    box-shadow: -50px 0 0 0 var(--background-primary), 50px 0 0 0 var(--background-primary);
  }

  @media (min-width: 1024px) and (max-width: 1199.97px) {
    max-width: 950px;
    border: 1px solid var(--control-minor);
  }

  @media (--from-desktop) {
    padding: 32px;
    margin-bottom: 48px;
    border: 1px solid var(--control-minor);
    border-radius: 8px;
  }
`;
